import axios from 'axios';

export class EventbriteAPI {
  constructor(apiKey) {
    this.client = axios.create({
      baseURL: 'https://www.eventbriteapi.com/v3/',
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    });
  }

  // Returns organization id
  async getOrganizationId() {
    const response = await this.client.get('users/me/organizations');
    const organizationId = response.data.organizations[0].id;
    return organizationId;
  }

  // Returns organization url for events page
  async getOrganizationUrl() {
    const organizationId = await this.getOrganizationId();
    const organizationResponse = await this.client.get(
      `organizations/${organizationId}/organizers`,
    );
    const organizationUrl = organizationResponse.data.organizers[0].url;
    return organizationUrl;
  }

  // Returns event data for a single event
  async getEvent(id) {
    const response = await this.client.get(`events/${id}?expand=venue`);
    return response.data;
  }

  // Can be used to retrieve data for multiple events by passing an array of 'event_id's
  async getEventsByIds(ids) {
    const eventsData = await Promise.all(
      ids.map(id => this.client.get(`events/${id}?expand=venue`)),
    );
    return eventsData.map(response => response.data);
  }
}
